import { render } from "./FormSubmit.vue?vue&type=template&id=6ededfa7"
import script from "./FormSubmit.vue?vue&type=script&lang=js"
export * from "./FormSubmit.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/sd-app-pipe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__